import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { TaskPanel } from './slate/TaskPanel';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * DepartmentTasksPanel — Slate Tasks scoped to one department by using a
 * synthetic channel_id (e.g. "dept-art", "dept-costume"). Reuses the existing
 * `<TaskPanel>` plumbing so we don't fork CRUD UI for each department.
 *
 * Loads project users (needed for assignee picker) and renders TaskPanel.
 *
 * Props:
 *   projectId  — project UUID
 *   department — "ART" | "COSTUME" (drives the synthetic channel_id)
 *   testId     — optional data-testid for the wrapper div
 */
export default function DepartmentTasksPanel({ projectId, department, testId }) {
  const { token } = useAuth();
  const [projectUsers, setProjectUsers] = useState([]);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/projects/${projectId}/users`, { headers })
      .then(r => { if (mounted) setProjectUsers(r.data || []); })
      .catch(() => { if (mounted) setProjectUsers([]); });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, token]);

  const channelId = `dept-${(department || 'art').toLowerCase()}`;

  return (
    <div data-testid={testId} className="h-[520px] rounded-lg overflow-hidden">
      <TaskPanel
        projectId={projectId}
        channelId={channelId}
        token={token}
        projectUsers={projectUsers}
      />
    </div>
  );
}
